import React from "react";

const InfoBlog = ({ vidRef, subtitle, title, src, flip }) => {
	return (
		<div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 mb-10">
			<div className="grid grid-cols-1 gap-y-12 sm:grid-cols-12 sm:gap-x-16 xl:gap-x-24" style={{ direction: flip ? "rtl" : "ltr" }}>
				<div className="text-center sm:col-span-6 sm:text-left">
					<h2 className="text-3xl font-bold text-slate-900 sm:text-4xl xl:text-5xl font-pj">{title}</h2>
					<p className="mt-8 text-base font-normal text-slate-600">{subtitle}</p>
				</div>
				<div className="sm:col-span-6">
					<video ref={vidRef} className="object-cover w-full max-h-48 transition-all duration-300 rounded-xl" src={src} alt="" loop muted autoPlay />
				</div>
			</div>
		</div>
	);
};

export default InfoBlog;
